// INMA-301: Hook para leer suscripción del usuario autenticado
import { useState, useEffect } from "react";
import { supabase } from "../supabase";
import { getSubscription, type Subscription, type PlanId, canAccessFeature } from "../lib/subscription";

interface UseSubscriptionResult {
  subscription: Subscription | null;
  loading: boolean;
  isActive: boolean;
  planId: PlanId;
  can: (requiredPlan: PlanId) => boolean;
}

export function useSubscription(): UseSubscriptionResult {
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { setLoading(false); return; }

      const sub = await getSubscription(user.id);
      if (!cancelled) {
        setSubscription(sub);
        setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, []);

  const isActive = subscription != null && ["active", "trialing"].includes(subscription.status);
  const planId: PlanId = isActive ? (subscription!.plan_id as PlanId) : "none";

  return {
    subscription,
    loading,
    isActive,
    planId,
    can: (requiredPlan) => canAccessFeature(subscription, requiredPlan),
  };
}
